import { render } from "./Vote.vue?vue&type=template&id=e2a92c04"
import script from "./Vote.vue?vue&type=script&lang=ts"
export * from "./Vote.vue?vue&type=script&lang=ts"
script.render = render

export default script